import "../report-styles/customTextField.scss";
import InfoBarSelection from "./infoBarSelection";
import DateRangePicker from "./dateRangePicker";
import SearchIcon from "../svgs/Search Duo.svg";
import React, { Component } from "react";
import CheckDoneIcon from "../svgs/Check_Done.svg";
import { ClickAwayListener } from "@material-ui/core";

export default class CustomTextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxSelection: {},
      localValue: "",
      searchTerm: "",
      isOpen: false,
    };
  }

  toggleOpen = (e) => {
    this.setState({ searchTerm: "" });
    if (this.state.isOpen) return;
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };
  onConfirm = () => {
    this.props.handleChange(this.state.localValue);
    this.setState({ isOpen: false });
  };

  render() {
    const item = this.props.item;
    const isOpen = this.state.isOpen;
    const isRequired = this.props.fields
      ? this.props.fields.fields[item.key].is_required
      : false;
    return (
      <div
        className={
          isOpen
            ? "custom-textfield-container active"
            : "custom-textfield-container"
        }
        onClick={this.toggleOpen}
      >
        <InfoBarSelection
          item={item}
          values={item.value}
          type="textfield"
          isRequired={isRequired}
        />
        {isOpen && (
          <ClickAwayListener onClickAway={this.onConfirm}>
            <div className="selection-overlay">
              <div className="customselect-search-bar-container">
                <InputBar
                  value={this.state.localValue}
                  label={item.label}
                  onChange={(e) =>
                    this.setState({ localValue: e.target.value })
                  }
                />
              </div>
              <button
                onClick={this.onConfirm}
                className="confirm-button"
                disabled={this.state.localValue.length === 0}
              >
                <img src={CheckDoneIcon} />
                Done
              </button>
            </div>
          </ClickAwayListener>
        )}
      </div>
    );
  }
}

const InputBar = ({ value, label, onChange }) => {
  return (
    <div className="input-bar-textfield">
      <input
        type="text"
        placeholder={`Type here`}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
